import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Manager from './Manager';




const UsersManagement = () => (
  <div>
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{
      marginBottom: '5px',
    }}
    >
      <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
      <Typography sx={{ color: 'text.primary' }}>User Manager</Typography>
      <Typography sx={{ color: 'text.primary' }}>Users Management</Typography>
    </Breadcrumbs>
    <Manager />
  </div>
  );

export default UsersManagement;
